module.exports = "<svg id=\"__26JTAbP__Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><title>info</title><g id=\"__26JTAbP__Home\"><g id=\"__26JTAbP__Form-R02\"><g id=\"__26JTAbP__Group-4\"><g id=\"__26JTAbP__Group-4-Copy\"><g id=\"__26JTAbP__Group-2-Copy\"><path id=\"__26JTAbP__Fill-1\" d=\"M10.89,11.07H9V7.21a1,1,0,0,0-1-1H6.07V8.18H7v2.89H5.11V13h5.79Z\"></path><path id=\"__26JTAbP__Fill-3\" d=\"M8,5.5A1.25,1.25,0,1,0,6.75,4.25,1.25,1.25,0,0,0,8,5.5\"></path></g></g></g></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/info.svg
// module id = 1525
// module chunks = 0